import { Badge } from '@/components/ui';
import { MetricCard } from './MetricCard';

/**
 * Stat card: rolling 7-day comparison. `thisWeek` is clicks in the last
 * 7 days, `lastWeek` is the 7 days before that. Rolling rather than
 * calendar-week — Monday morning of a calendar week comparing partial
 * vs full last week would always print misleading negatives.
 *
 * Mirrors TodayVsYesterdayCard's shape so the two cards sit naturally
 * side-by-side on the Overview dashboard.
 */
export function WeekVsLastWeekCard({
  weekDelta,
}: {
  weekDelta: { thisWeek: number; lastWeek: number };
}) {
  const { thisWeek, lastWeek } = weekDelta;
  let badgeText: string;
  let badgeTone: 'secondary' | 'error' | 'neutral' = 'neutral';
  if (lastWeek === 0 && thisWeek === 0) {
    badgeText = 'No traffic yet this week';
  } else if (lastWeek === 0) {
    badgeText = 'New vs last week';
    badgeTone = 'secondary';
  } else {
    const pct = ((thisWeek - lastWeek) / lastWeek) * 100;
    const sign = pct >= 0 ? '+' : '';
    badgeText = `${sign}${pct.toFixed(0)}% vs last week`;
    badgeTone = pct >= 0 ? 'secondary' : 'error';
  }
  return (
    <MetricCard
      label="This week vs last"
      value={thisWeek.toLocaleString()}
      badge={<Badge tone={badgeTone}>{badgeText}</Badge>}
      meta={
        <span title="Rolling 7-day window — last 7 days vs the 7 days before that.">
          {lastWeek.toLocaleString()} prior 7d
        </span>
      }
    />
  );
}
